import { useState, useCallback } from 'react'

const useShrink = () => {
  const [isShrink, toggle] = useState(false)

  const toggleShrink = useCallback(
    (shrink?: boolean) => {
      if (typeof shrink === 'boolean') {
        toggle(shrink)
        return
      }
      toggle((currentShrink) => !currentShrink)
    },
    [toggle],
  )

  return {
    isShrink,
    toggleShrink,
  }
}

export default useShrink
